export default "__VITE_ASSET__DRk$$fXA__"